module.exports = __webpack_public_path__ + "static/CVS-Catch-E-cigarettes-Risks-Core-ANIMATIONS-2b762666e555dd76ba2817fe2e0a71a7.pdf";